module.exports = __webpack_public_path__ + "static/fonts/ProximaNovaT-Thin.8f0bc01c.otf";